import * as Styled from './styled';
import type { ProgressProps } from './types';

export const Progress = (props: ProgressProps) => {
  const { total, current } = props;

  const items = [];
  for (let i = 1; i <= total; i += 1) {
    const isFull = i <= current || total === current;
    items.push(<Styled.Item key={i} isFull={isFull} />);
  }

  return <Styled.Wrapper>{items}</Styled.Wrapper>;
};
